<template funtional>
  <div class="">
    <div v-if="twoColum" class="flex justify-center">
      <div class="flex w-1/4">
        <img v-if="variant == 2" :src="getImage('empty_state_2.svg')"/>
        <img v-else-if="variant == 1" :src="getImage('empty_state_1.svg')"/>
        <img v-else-if="variant == 4" :src="getImage('empty_state_4.svg')"/>
        <img v-else :src="getImage('empty_state_3.svg')"/>
      </div>

      <div class="text-center w-2/5 flex flex-wrap content-center justify-center">
        <p class="text-center font-semibold md:text-xl">{{title}}</p>
        <p class="text-center">{{subtitle}}</p>
      </div>
    </div>
    <div v-else>
      <div class="flex justify-center ">
        <img v-if="variant == 2" :src="getImage('empty_state_2.svg')" class="max-w-xs mx-auto"/>
        <img v-else-if="variant == 1" :src="getImage('empty_state_1.svg')" class="max-w-xs mx-auto"/>
        <img v-else-if="variant == 4" :src="getImage('empty_state_4.svg')" class="max-w-xs mx-auto"/>
        <img v-else :src="getImage('empty_state_3.svg')" class="max-w-xs mx-auto"/>
      </div>

      <div class="text-center">
          <p class="font-semibold md:text-xl">{{title}}</p>
          <p class="mt-2">{{subtitle}}</p>
          <p class="font-italic mt-2">{{subtitle2}}</p>
      </div>

      <div class="text-center">
        <slot></slot>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle', 'variant', 'twoColum', 'subtitle2'],
  methods: {
    getImage (filename) {
      return require(`@/assets/images/empty/${filename}`)
    },
  }
}
</script>


<style>
.empty-state-gray {
  color: #989898
}

</style>
